function OutputDate({ field, object, collection }) {
  const value = object[field];
  const format = collection.fields[field]?.format;

  if (value && new Date(value) !== "Invalid Date") {
    if (format || field === "date") {
      return new Date(value).toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }

    if (["createdAt", "created", "updatedAt", "updated"].includes(field)) {
      if (value === "Invalid Date") return value;

      const date = new Date(value);

      // Proper validation for invalid date
      if (isNaN(date.getTime())) {
        return value; // Return original value if invalid
      }

      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Manila",
      });
    }

    if (
      [
        "startTime",
        "endTime",
        // "createdAt",
        // "created",
        // "updatedAt",
        // "updated",
        "dateApproved",
        "update",
        "create",
        "timestamp",
      ].includes(field)
    ) {
      if (value === "Invalid Date") return value;

      const date = new Date(value);

      // Proper validation for invalid date
      if (isNaN(date.getTime())) {
        return value; // Return original value if invalid
      }

      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: "UTC",
      });
    }

    const date = new Date(value);

    // Proper validation for invalid date values.
    if (isNaN(date.getTime())) return value;

    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }
  return null;
}

export default OutputDate;
